import { Stack, Typography } from '@mui/material';
import {
  CompaniesCarousel,
  MacBookWindow,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={
          <>
            Make your customers fall in love <br /> with your product’s design
          </>
        }
        description={<>Elevate your brand with cutting-edge UX/UI design</>}
        buttonText="Book a free consultation"
        buttonLink="/contact"
        gradient="lightBlue"
      />

      <Section width="normal">
        <Stack
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(7),
            marginTop: theme.spacing(6),
            textAlign: 'center',
            marginBottom: theme.spacing(16),
            [theme.breakpoints.down('md')]: {
              marginBottom: theme.spacing(15),
            },
            [theme.breakpoints.down('sm')]: {
              marginBottom: theme.spacing(9),
            },
          })}>
          <Typography
            sx={{
              color: (theme) => theme.palette.invertedContent?.PRIMARY,
            }}
            variant="strong_400">
            At Rumble Fish, we understand that a great UI/UX can make or break
            your digital product success. After all, you never have a second
            chance to make a great first impression. <br />
            That’s why having a smooth user experience is so crucial for your
            brand - you only have one chance to make your customers fall in love
            with your product!
          </Typography>
          <CompaniesCarousel />
        </Stack>
      </Section>
    </>
  );
};
